// "Back" links point at the relevant archive server-side. When the visitor
// arrived from another page on the site, go back to that instead, so a filtered
// or paginated archive (/work/page/2/?strategy=N) is restored as they left it.
export default class BackLink {
    constructor() {
        const links = [...document.querySelectorAll('.js-back-link')];

        if (!links.length) return;

        this.referrer = this.internalReferrer();

        if (!this.referrer) return;

        this.hashChanged = window.location.hash !== '';
        window.addEventListener('hashchange', () => {
            this.hashChanged = true;
        });

        links.forEach((link) => link.addEventListener('click', (e) => this.onClick(e)));
    }

    // The referring page, if it was another page on this site (and not the
    // current one, which would mean a reload or a self-referencing link).
    internalReferrer() {
        if (!document.referrer) return null;

        let url;

        try {
            url = new URL(document.referrer);
        } catch {
            return null;
        }

        if (url.origin !== window.location.origin) return null;
        if (url.pathname.startsWith('/wp/wp-admin') || url.pathname.startsWith('/wp/wp-login')) return null;
        if (url.href === window.location.href) return null;

        return url.href;
    }

    onClick(e) {
        e.preventDefault();

        // history.back() keeps the previous page's scroll position; the URL
        // fallback is for when the history stack no longer lines up.
        if (this.hashChanged) {
            window.location.assign(this.referrer);
            return;
        }

        window.history.back();
    }
}
